var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            title: _vm.$t("message.capiEventModalTitle"),
            okText: _vm.$t("message.send"),
            cancelText: _vm.$t("message.cancel"),
          },
          on: { cancel: _vm.handleCancel, ok: _vm.handleSend },
        },
        [
          _c("div", { staticClass: "send-capi-event-form" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.capiChannelLabel")) + " "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: _vm.$t(
                        "message.capiSelectChannelPlaceholder"
                      ),
                      readonly: "",
                      disabled: "",
                    },
                    on: { change: _vm.handleChannelChange },
                    model: {
                      value: _vm.form.channelId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelId", $$v)
                      },
                      expression: "form.channelId",
                    },
                  },
                  _vm._l(_vm.availableChannels, function (channel) {
                    return _c(
                      "a-select-option",
                      { key: channel._id, attrs: { value: channel._id } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(channel.name) +
                            " (" +
                            _vm._s(channel.type) +
                            ")\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("message.capiEventTypeLabel")) + " "),
                  _c("span", { staticClass: "required" }, [_vm._v("*")]),
                ]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: _vm.$t("message.capiEventTypePlaceholder"),
                    },
                    model: {
                      value: _vm.form.eventType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "eventType", $$v)
                      },
                      expression: "form.eventType",
                    },
                  },
                  [
                    _c(
                      "a-select-option",
                      { attrs: { value: "LeadSubmitted" } },
                      [_vm._v(_vm._s(_vm.$t("message.capiEventLeadSubmitted")))]
                    ),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "Purchase" } }, [
                      _vm._v(_vm._s(_vm.$t("message.capiEventPurchase"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "InitiateCheckout" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.capiEventInitiateCheckout"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "AppointmentBooked" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("message.capiEventAppointmentBooked"))
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "AddToCart" } }, [
                      _vm._v(_vm._s(_vm.$t("message.capiEventAddToCart"))),
                    ]),
                    _vm._v(" "),
                    _c("a-select-option", { attrs: { value: "ViewContent" } }, [
                      _vm._v(_vm._s(_vm.$t("message.capiEventViewContent"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "OrderCreated" } },
                      [_vm._v(_vm._s(_vm.$t("message.capiEventOrderCreated")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a-select-option",
                      { attrs: { value: "OrderShipped" } },
                      [_vm._v(_vm._s(_vm.$t("message.capiEventOrderShipped")))]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            ["Purchase", "OrderCreated", "OrderShipped"].includes(
              _vm.form.eventType
            )
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.capiCurrencyLabel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t(
                            "message.capiCurrencyPlaceholder"
                          ),
                        },
                        model: {
                          value: _vm.form.currency,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "currency", $$v)
                          },
                          expression: "form.currency",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "TRY" } }, [
                          _vm._v(_vm._s(_vm.$t("message.currencyOptionTRY"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "USD" } }, [
                          _vm._v(_vm._s(_vm.$t("message.currencyOptionUSD"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "EUR" } }, [
                          _vm._v(_vm._s(_vm.$t("message.currencyOptionEUR"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "GBP" } }, [
                          _vm._v(_vm._s(_vm.$t("message.currencyOptionGBP"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            ["Purchase", "OrderCreated", "OrderShipped"].includes(
              _vm.form.eventType
            )
              ? _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.capiAmountLabel"))),
                    ]),
                    _vm._v(" "),
                    _c("a-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: _vm.$t("message.capiAmountPlaceholder"),
                        min: 0,
                        step: 0.01,
                      },
                      model: {
                        value: _vm.form.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "value", $$v)
                        },
                        expression: "form.value",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("message.capiCustomDataLabel"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "custom-data-list" },
                [
                  _vm._l(_vm.form.customDataList, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "custom-data-item" },
                      [
                        _c("a-input", {
                          staticStyle: { width: "40%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "message.capiCustomDataKeyPlaceholder"
                            ),
                          },
                          model: {
                            value: item.key,
                            callback: function ($$v) {
                              _vm.$set(item, "key", $$v)
                            },
                            expression: "item.key",
                          },
                        }),
                        _vm._v(" "),
                        _c("a-input", {
                          staticStyle: { width: "50%" },
                          attrs: {
                            placeholder: _vm.$t(
                              "message.capiCustomDataValuePlaceholder"
                            ),
                          },
                          model: {
                            value: item.value,
                            callback: function ($$v) {
                              _vm.$set(item, "value", $$v)
                            },
                            expression: "item.value",
                          },
                        }),
                        _vm._v(" "),
                        _c("SupsisButton", {
                          attrs: { danger: "", icon: "delete" },
                          on: {
                            click: function ($event) {
                              return _vm.removeCustomData(index)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      attrs: { icon: "add" },
                      on: { click: _vm.addCustomData },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.capiAddFieldButton")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.contact
              ? _c("div", { staticClass: "info-section" }, [
                  _c("h4", [
                    _vm._v(_vm._s(_vm.$t("message.capiContactInfoHeading"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-grid" }, [
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(_vm._s(_vm.$t("message.capiContactNameLabel"))),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(_vm.contact.fullname || _vm.$t("message.na"))
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-item" }, [
                      _c("span", { staticClass: "label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.capiContactPlatformLabel"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.contact.platform)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.contact.meta_ids
                      ? _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.capiContactMetaIdLabel"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.getMetaIdDisplay())),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }